<mat-card class="dashboard-graph">
    <div id="main-graphs-slider" class="carousel slide" *ngIf="graphs.length > 0; else graphEmpty"
         data-ride="carousel" data-interval="false">
        <div class="dashboard-graph-menu">
            <mat-form-field id="graphName" class="mxs-input">
                <mat-label>{{ getLabel("label.dashboard.graph") }}</mat-label>
                <mat-select hideSingleSelectionIndicator="true"
                            [formControl]="selectedGraphControl"
                            (selectionChange)="loadSelectedGraph()"
                            required>
                    <mat-option *ngFor="let graph of graphs" [value]="graph">{{ graph.value }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field id="campaignName" class="mxs-input">
                <mat-label>{{ getLabel("label.stats.campaigns") }}</mat-label>
                <mat-select hideSingleSelectionIndicator="true"
                            [formControl]="selectedCampaignControl"
                            (selectionChange)="loadSelectedGraph()"
                            required>
                    <mat-option *ngFor="let campaign of campaigns" [value]="campaign">{{ campaign.value }}</mat-option>
                </mat-select>
            </mat-form-field>
            <div class="buttons">
                <mx-button [buttonModel]="refreshButton"></mx-button>
                <mx-button *ngIf="advancedFields.length !== 0" [buttonModel]="advancedFieldsButton"></mx-button>
            </div>
        </div>

        <div class="dashboard-graph-body">
            <div class="graph-container">
                <div class="graph-container_header">
                    <span class="graph-container_header_text">{{ getGraphTitle() }}</span>
                </div>
                <mx-preloader [preloaderName]="preloaderName" type="RoundSpinner"></mx-preloader>
                <highcharts-chart class="mx-chart" oneToOne="true"
                                  [(update)]="isUpdateChart"
                                  [options]="chartOptions"
                                  (chartInstance)="onChartInstance($event)"></highcharts-chart>
                <div class="multiple-columns">
                    <mx-form (customize)="onCustomizeFilters($event)"></mx-form>
                </div>
            </div>
        </div>
    </div>
    <ng-template #graphEmpty>
        <div class="empty-graph" *ngIf="initialized">
            <mat-icon>info</mat-icon>
            <prl-label value="label.no.graph.or.report"/>
        </div>
    </ng-template>
</mat-card>
